import { render, staticRenderFns } from "./DomainsView.vue?vue&type=template&id=a3a88432&"
import script from "./DomainsView.vue?vue&type=script&lang=js&"
export * from "./DomainsView.vue?vue&type=script&lang=js&"
import style0 from "./DomainsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports